import { Component, OnInit, OnDestroy } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { SharedModule } from "shared-ui/shared.module";
import { setWidgetNumberLocale, WidgetMessages } from "shared-ui/localization/widget-number-locale";
import { HttpClient } from "@angular/common/http";
import { TranslocoService } from "@jsverse/transloco";
import { Subject, forkJoin, takeUntil } from "rxjs";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: true,
    imports: [RouterOutlet, SharedModule],
})
export class AppComponent implements OnInit, OnDestroy {
    private _unsubscribeAll = new Subject<void>();
    private widgetMessages: WidgetMessages = {};

    /**
     * Constructor
     */
    constructor(
        private http: HttpClient,
        private _translocoService: TranslocoService,
    ) {}

    ngOnInit(): void {
        // Đường dẫn TƯƠNG ĐỐI, không có dấu "/" đầu — trình duyệt phân giải theo <base href> của trang.
        //
        // Trên domain tenant, app quản trị được phục vụ dưới "/admin/" (<base href="/admin/">) còn gốc "/"
        // là public-site. Dấu "/" đầu bỏ qua base href, nên "/i18n/devextreme/en.json" rơi vào public-site,
        // không có tệp đó và IIS trả về index.html của public-site — HttpClient nhận HTML rồi ngã ở
        // JSON.parse: 'Unexpected token <'. Kết quả là DevExtreme mất toàn bộ chuỗi bản địa hoá.
        //
        // Bộ nạp của Transloco (`TranslocoHttpLoader`, prefix "i18n/") vốn đã tương đối — ba dòng này là
        // chỗ duy nhất trong app còn lệch.
        // Version message assets so existing browser caches receive the editor translations.
        forkJoin({
            vi: this.http.get<any>("i18n/devextreme/vi.json?v=20261020-work-editor"),
            en: this.http.get<any>("i18n/devextreme/en.json?v=20261020-work-editor"),
            de: this.http.get<any>("i18n/devextreme/de.json?v=20261020-work-editor"),
        }).subscribe(({ vi, en, de }) => {
            this.widgetMessages = { ...en, ...vi, ...de };
            setWidgetNumberLocale(this._translocoService.getActiveLang(), this.widgetMessages);
        });

        this._translocoService.langChanges$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((lang) => {
                setWidgetNumberLocale(lang, this.widgetMessages);
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
